import { Link } from "react-router-dom";
import Header from "../components/Header/Header";
import PageBanner from "../components/about/PageBanner";
import Counter from "../components/Counter";
import Footer from "../components/Footer/Footer";
import { Fade } from "react-awesome-reveal";
import AboutCube from "../components/about/AboutCube";
import ImageMasonry from "../components/masonary/MasonaryAbout";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchTranslations } from "../actions/languageActions";
import NewHeader from "../components/Header/NewHeader";
import Loading from "../components/loading/Loading";
import FormModal from "../elements/FormModal";
import { Helmet } from "react-helmet-async";
import FormModalOne from "../elements/FormModalOne";
// import Typewriter from "typewriter-effect";
const handleChnge = () => {
  onclick = "window.print()";
};
const FAQ = () => {
  const dispatch = useDispatch();
  const selectedLanguage = useSelector((state) => state.language.selectedLanguage);
  const translations = useSelector((state) => state.language.translations[selectedLanguage]);
  
  useEffect(() => {
    dispatch(fetchTranslations(selectedLanguage));
  }, [dispatch, selectedLanguage]);
  
  if (!translations) {
    return <div>
      <Loading/>
    </div>; // Show loading state while translations are being fetched
  }
  
  const { aboutus } = translations;
  const industryList = aboutus.industry.list;
  const learnUs = aboutus.learnUs.list;
  return (
    <>
      <Helmet>
<title>Frequently Asked Questions - Signet Institute Australia</title>
<meta name='description' content='Find answers to common questions about Signet courses, enrolment, fees, study options and student support. Get the information you need today.' data-rh="true" />
</Helmet>
      <NewHeader />
      {/* <PageBanner pageName={"About us"} /> */}

      {/* <Fade delay={1e3} triggerOnce cascade damping={1e-5}> */}

      {/* page banner */}

      {/* page banner */}
      {/* Page Banner End */}

      <div className="about-sec-">
        <section class="pt-150">
        
          <div className="container">
            <div className="row">
              <div className="col-md-8 pt-60">
                <h1 className="title-banner ">
                Frequently Asked Questions (FAQs)
                </h1>
                <p>Greetings to the Signet Institute of Australia FAQ page. We have gathered questions along with their answers that we hear most often from our current and future students. Whether you want information about our courses, how to enroll in our institute, or the services we offer, this FAQ section is designed especially for you to answer all your queries and make you doubt-free. So you can proceed forward without any questions in your mind and choose the course according to your interest.

</p>
              </div>
              <div className="col-md-4">
                  <img src="../img/policy/faq.png" width="350" />
              </div>
            </div>
          </div>
        </section>
        <section class="about-page-section pt-60 pb-65 rpt-90">
            <div className="container">
                <div className="row">
                   <div className="col-md-12 pt-20">
                        <div class="faq-drawer">
                          <input class="faq-drawer__trigger" id="faq-drawer-1" type="checkbox" /><label class="faq-drawer__title" for="faq-drawer-1"><h5>What types of courses are offered at Signet Institute?</h5></label>
                          <div class="faq-drawer__content-wrapper">
                            <div class="faq-drawer__content">
                            <p>Signet Institute provides a diverse range of vocational education and training (VET) programs, including courses in:
                           <ul><li> Automotive</li>
                           <li> Business</li>
                           <li> Construction</li>
                           <li> Community</li>
                           <li> Healthcare</li>
                           <li> General English</li>
                           <li> Manufacturing and Engineering</li>
                            </ul>
                            For detailed information about each program, please visit the respective course
                            pages on our website.
                            </p>
                                </div>
                          </div>
                        </div>
                        <div class="faq-drawer">
                          <input class="faq-drawer__trigger" id="faq-drawer-2" type="checkbox" /><label class="faq-drawer__title" for="faq-drawer-2"><h5>Where are Signet Institute’s campuses located?</h5></label>
                          <div class="faq-drawer__content-wrapper">
                            <div class="faq-drawer__content">
                                <p>We have campuses in Melbourne, Sydney, and Adelaide, each equipped with modern facilities and easy access to public transport.</p>
                                </div>
                          </div>
                        </div>
                        <div class="faq-drawer">
                          <input class="faq-drawer__trigger" id="faq-drawer-3" type="checkbox" /><label class="faq-drawer__title" for="faq-drawer-3"><h5>Is Signet Institute nationally accredited?</h5></label>
                          <div class="faq-drawer__content-wrapper">
                            <div class="faq-drawer__content">
                              <p>Yes, Signet Institute is a Registered Training Organisation (RTO Code: 40898) and CRICOS-approved (Code: 03377J), meeting national education standards.</p> 
                            </div>
                          </div>
                        </div>
                        
                        <div class="faq-drawer">
                          <input class="faq-drawer__trigger" id="faq-drawer-4" type="checkbox" /><label class="faq-drawer__title" for="faq-drawer-4"><h5>What support is available for current students?</h5></label>
                          <div class="faq-drawer__content-wrapper">
                            <div class="faq-drawer__content">
                            <p>Students can access academic assistance, career guidance, and support services through our dedicated team at each campus.
</p>
                            </div>
                          </div>
                        </div>
                        <div class="faq-drawer">
                          <input class="faq-drawer__trigger" id="faq-drawer-5" type="checkbox" /><label class="faq-drawer__title" for="faq-drawer-5"><h5>Can international students enrol at Signet Institute? </h5></label>
                          <div class="faq-drawer__content-wrapper">
                            <div class="faq-drawer__content">
                            <p>Absolutely. We welcome students from around the globe and offer CRICOS-registered courses designed for international learners.</p>
                            </div>
                          </div>
                        </div>
                        <div class="faq-drawer">
                          <input class="faq-drawer__trigger" id="faq-drawer-6" type="checkbox" /><label class="faq-drawer__title" for="faq-drawer-6"><h5>How do I enroll in a course at Signet Institute? </h5></label>
                          <div class="faq-drawer__content-wrapper">
                            <div class="faq-drawer__content">
                            <p>You can apply online through our website or contact us directly at one of our campus locations for personal assistance.</p>
                            </div>
                          </div>
                        </div>

                        <div class="faq-drawer">
                          <input class="faq-drawer__trigger" id="faq-drawer-7" type="checkbox" /><label class="faq-drawer__title" for="faq-drawer-7"><h5>What English language support does Signet offer?</h5></label>
                          <div class="faq-drawer__content-wrapper">
                            <div class="faq-drawer__content">
                            <p>We provide a General English course designed to improve communication, writing, and comprehension skills for academic and professional success.</p>
                            </div>
                          </div>
                        </div>

                        <div class="faq-drawer">
                          <input class="faq-drawer__trigger" id="faq-drawer-8" type="checkbox" /><label class="faq-drawer__title" for="faq-drawer-8"><h5>Does Signet have flexible education options?</h5></label>
                          <div class="faq-drawer__content-wrapper">
                            <div class="faq-drawer__content">
                            <p>Yes, we offer flexible learning options, with both in-person classes and blended learning to suit different schedules and learning preferences.</p>
                            </div>
                          </div>
                        </div>

                        <div class="faq-drawer">
                          <input class="faq-drawer__trigger" id="faq-drawer-9" type="checkbox" /><label class="faq-drawer__title" for="faq-drawer-9"><h5>Does Signet help with career preparation?</h5></label>
                          <div class="faq-drawer__content-wrapper">
                            <div class="faq-drawer__content">
                            <p>Yes, our courses include practical training and industry-aligned skills to prepare students for real-world employment.</p>
                            </div>
                          </div>
                        </div>

                        <div class="faq-drawer">
                          <input class="faq-drawer__trigger" id="faq-drawer-10" type="checkbox" /><label class="faq-drawer__title" for="faq-drawer-10"><h5>How can I become an instructor at Signet Institute?</h5></label>
                          <div class="faq-drawer__content-wrapper">
                            <div class="faq-drawer__content">
                            <p>We are always looking for passionate professionals to join our teaching team. Visit the Careers page to learn more and apply.</p>
                            </div>
                          </div>
                        </div>

                        <div class="faq-drawer">
                          <input class="faq-drawer__trigger" id="faq-drawer-11" type="checkbox" /><label class="faq-drawer__title" for="faq-drawer-11"><h5>What makes Signet different from other institutes?</h5></label>
                          <div class="faq-drawer__content-wrapper">
                            <div class="faq-drawer__content">
                            <p>Our commitment to student success, hands-on learning, experienced faculty, and modern facilities set us apart.
                            </p>
                            </div>
                          </div>
                        </div>

                        <div class="faq-drawer">
                          <input class="faq-drawer__trigger" id="faq-drawer-12" type="checkbox" /><label class="faq-drawer__title" for="faq-drawer-12"><h5>What are the entry requirements for different courses?</h5></label>
                          <div class="faq-drawer__content-wrapper">
                            <div class="faq-drawer__content">
                            <p>Entry requirements vary by course. Generally, you’ll need to meet educational prerequisites and, for some courses, demonstrate English proficiency.</p>
                            </div>
                          </div>
                        </div>

                        <div class="faq-drawer">
                          <input class="faq-drawer__trigger" id="faq-drawer-13" type="checkbox" /><label class="faq-drawer__title" for="faq-drawer-13"><h5>What kind of qualifications will I receive after completing a course?</h5></label>
                          <div class="faq-drawer__content-wrapper">
                            <div class="faq-drawer__content">
                            <p>Students receive a nationally recognised certificate or diploma, depending on the course completed.</p>
                            </div>
                          </div>
                        </div>

                        <div class="faq-drawer">
                          <input class="faq-drawer__trigger" id="faq-drawer-14" type="checkbox" /><label class="faq-drawer__title" for="faq-drawer-14"><h5>Are there any scholarship or financial support options available?</h5></label>
                          <div class="faq-drawer__content-wrapper">
                            <div class="faq-drawer__content">
                            <p>While we don’t currently offer scholarships, we encourage students to explore payment plans or speak with our advisors for flexible options.</p>
                            </div>
                          </div>
                        </div>

                        <div class="faq-drawer">
                          <input class="faq-drawer__trigger" id="faq-drawer-15" type="checkbox" /><label class="faq-drawer__title" for="faq-drawer-15"><h5>How can I visit a campus or book a virtual tour?</h5></label>
                          <div class="faq-drawer__content-wrapper">
                            <div class="faq-drawer__content">
                            <p>You can book a personal visit to our campus with the help of a contact page or you can go through our website and experience online.</p>
                            </div>
                          </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </section>
      </div>
      {/* </Fade> */}
      <Footer />
    </>
  );
};
export default FAQ;
